import { InjectionToken } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';

export const BUDDY_AUTH_SERVICE_TOKEN = new InjectionToken<AuthService>('AuthService');
